// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__p4iv4","addWidgetButton":"Header_addWidgetButton__2gKPz","dashboardTabs":"Header_dashboardTabs__1M8Yd","active":"Header_active__2_M37"};